import Video1 from "../../assets/video/video-1.mp4";
import Poster1 from "../../assets/img/instagramhome.jpg";
import Poster2 from "../../assets/img/tiktokhome.jpg";
import Poster3 from "../../assets/img/posters/poster-video-1.jpg";

export default function UseCases() {
  return (
    <div className="relative bg-gray-50 px-4 pt-16 pb-20 sm:px-6 lg:px-8 lg:pt-24 lg:pb-28">
      <div className="absolute inset-0">
        <div className="h-1/3 bg-white sm:h-2/3" />
      </div>

      <div className="relative container mx-auto">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-yellow-button sm:text-4xl">
          Conoce nuestro impacto
          </h2>
        </div>

        <div className="mx-auto mt-12 grid gap-6 lg:grid-cols-2">
          
          {/* 🎬 VIDEO IZQUIERDA */}
          <div className="flex flex-col overflow-hidden rounded-2xl shadow-lg bg-white border-2 ">
            <video
              className="w-full aspect-video rounded-2xl object-cover"
              src={Video1}
              controls
              poster={Poster3}
            />

            <div className="p-6">
              <div className="text-sm font-medium text-yellow-button">
              Nuestra historia
              </div>
              <p className="mt-2 text-xl font-semibold text-gray-900">
              Conoce cómo desde la Fundación Arduvi trabajamos por el bienestar y la transformación de nuestra comunidad.
              </p>
            </div>
          </div>

          {/* 🖼️ FOTOS DERECHA */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            
            {/* 📱 Instagram */}
            <a
              href="https://www.instagram.com/fundacionarduvi?igsh=aWE3dTQxa2lzN2pi"
              target="_blank"
              rel="noopener noreferrer"
              className="overflow-hidden rounded-2xl shadow-lg bg-white block border-2 border-yellow-button hover:scale-105 transition-transform duration-300"
            >
              <img
                src={Poster1}
                alt="Instagram Fundación Arduvi"
                className="w-full h-[480px] object-cover"
              />
              <div className="p-4 text-center">
                <div className="text-sm font-medium text-yellow-button">
                  Instagram
                </div>
                <p className="mt-1 text-lg font-semibold text-gray-900">
                Cada acción cuenta. Descubre el impacto real que estamos generando juntos
                </p>
              </div>
            </a>

            {/* 🎵 TikTok */}
            <a
              href="https://www.tiktok.com/@fundacionarduvi?_r=1&_t=ZS-943ohcmjgqz"
              target="_blank"
              rel="noopener noreferrer"
              className="overflow-hidden rounded-2xl shadow-lg bg-white block border-2 border-yellow-button hover:scale-105 transition-transform duration-300"
            >
              <img
                src={Poster2}
                alt="TikTok Fundación Arduvi"
                className="w-full h-[480px] object-cover"
              />
              <div className="p-4 text-center">
                <div className="text-sm font-medium text-yellow-button">
                  TikTok
                </div>
                <p className="mt-1 text-lg font-semibold text-gray-900">
                Mira cómo estamos cambiando vidas a través de nuestras iniciativas sociales.
                </p>
              </div>
            </a>

          </div>
        </div>
      </div>
    </div>
  );
}